module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-mood"
  }, [(_vm.mood == 'positive') ? _c('img', {
    staticClass: "mood-icon",
    attrs: {
      "src": "/static/img/mood--positive.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mood == 'negative') ? _c('img', {
    staticClass: "mood-icon",
    attrs: {
      "src": "/static/img/mood--negative.svg"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05424b5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ReviewMood/ReviewMood.vue
// module id = 528
// module chunks = 1